import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

/**
 * Action to initialize shared folders
 */
export interface INITIALIZE_SHARED_FOLDERSActionMessage {
    mailboxInfo: MailboxInfo;
}
export const initializeSharedFolderRoots: (mailboxInfo: MailboxInfo) => INITIALIZE_SHARED_FOLDERSActionMessage = action("INITIALIZE_SHARED_FOLDERS", (mailboxInfo: MailboxInfo): INITIALIZE_SHARED_FOLDERSActionMessage => {
    return {
        mailboxInfo,
    };
});
